const header = "px-3 py-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider border-b border-border/60 shrink-0";

const logPanel = "flex-1 min-h-0 overflow-y-auto p-3 space-y-1 font-mono text-sm bg-muted/30 rounded-md";

const logEntry = "px-2 py-0.5 text-muted-foreground border-b border-border/30 last:border-b-0";

const timestamp = "text-muted-foreground mr-2 shrink-0";

const logGroupHeader = "flex items-center gap-2 mb-1.5 mt-2";

const logGroupHeaderTitle = "text-xs font-semibold text-foreground";

export { header, logPanel, logEntry, timestamp, logGroupHeader, logGroupHeaderTitle };
